module.exports = __webpack_public_path__ + "img/case.93aae40c.jpeg";